export default "__VITE_ASSET__Cvq2NyDi__"